
import { defineComponent } from "vue";
import { OrderTotal } from "./index.ts";

export default defineComponent({
  setup() {
    return { ...OrderTotal() };
  },
});
